import TotalPlCellValue from './TotalPlCellValue';

export default TotalPlCellValue;
